"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var components_1 = require("components");
var drawerItems_1 = require("./drawerItems");
var pages_1 = require("./pages");
var componentStyle = {
    base: {
        display: 'flex',
        height: '100vh',
        backgroundColor: '#ececec',
        flexDirection: 'column',
    },
};
var DocsApp = (function (_super) {
    __extends(DocsApp, _super);
    function DocsApp() {
        var _this = _super.call(this) || this;
        _this.setCurrentPage = function (page) {
            _this.setState({ currentPage: page });
        };
        _this.state = {
            currentPage: pages_1.ComponentAppBarPage,
        };
        return _this;
    }
    DocsApp.prototype.render = function () {
        return (React.createElement("div", { style: componentStyle.base },
            React.createElement(components_1.AppBar, { title: "JS Channel - UI Kit", hideToggleDrawerIconButton: true }),
            React.createElement(components_1.LayoutBody, { drawerItems: drawerItems_1.getDrawerItems(this.setCurrentPage), drawerOpen: true }, this.renderCurrentPage())));
    };
    DocsApp.prototype.renderCurrentPage = function () {
        return React.createElement(this.state.currentPage);
    };
    return DocsApp;
}(react_1.PureComponent));
exports.DocsApp = DocsApp;



//////////////////
// WEBPACK FOOTER
// ./src/docs/DocsApp.tsx
// module id = 228
// module chunks = 0